import { LocationStrategy } from '@angular/common';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AnalyticsService } from 'src/app/common/services/device.analytics.service';
import { environment } from '../environments/environment';
import { adobe_analytics_service } from './common/services/adobe_analytics_service';
import { AppIdleService } from './common/services/app-idle.service';
import { CookieHandlerService } from './common/services/cookieHandler.service';
import { EmitterService } from './common/services/emitter.service';
import { RouteHandlerService } from './common/services/routeHandler.service';
import { SessionHandlerService } from './common/services/sessionHandler.service';
import { SharedService } from './common/services/sharedService';
import { CommonConstants } from './common/utilities/commonConstants';
import { DrawerComponent } from './common/utilities/drawer/drawer.component';
import { PopupComponent } from './common/utilities/popup/popup.component';
import { NeedHelpService } from './shared/services/needHelp.service';
import { RouteContextProvider } from './common/services/routeContextProvider.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewChecked, AfterViewInit, OnInit, OnDestroy {
  title = 'app';
  // Bajaj Logo goes here
  public bajajclassLogo = 'assets/img/bfs-logo-mod.png';
  public angularclassLogo = 'assets/img/angularclass-avatar.png';
  public name = 'This is test page';
  public url = 'some URL';
  public HasError: boolean;
  public IsLoadingTask = false;
  public showToggle = false;
  tempShow = false;
  public bflJourney = false;
  public counting: number;
  countDownTimer;
  public sessionExpired: boolean;
  public count: number;
  public show = true;
  public Config = { show: false, backdrop: 'static' };
  @ViewChildren(PopupComponent) public PopupComponent: QueryList<any>;
  ContentPopup: { Id: string; Title: string; Config: CustomModalOptions; };
  @ViewChildren(DrawerComponent) public drawer: QueryList<DrawerComponent>;
  isDrawerOpen: boolean;
  clevertap: any;
  isMobileFlag: string;

  constructor(
    private _cookieHandlerService: CookieHandlerService,
    private _sessionHandler: SessionHandlerService,
    private _routerService: RouteHandlerService,
    private _sharedservice: SharedService,
    private _emitterService: EmitterService,
    private cdRef: ChangeDetectorRef,
    private _analyticsService: AnalyticsService,
    private renderer: Renderer2,
    private _sharedService: SharedService,
    private location: LocationStrategy,
    private _adobe_analytics_service: adobe_analytics_service,
    private router: Router,
    private _appIdleService: AppIdleService,
    public _needHelpService: NeedHelpService,
    private _routeContextProvider: RouteContextProvider
  ) { }

  public ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngAfterViewInit(): void {
    this.listenToHelpCtaEvent();
    this.loadAnalyticScript();
  }

  public ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    this.isMobileFlag = urlParams.get('isMobile');
    this.getGeoLocationAttributes();
    this.loadClevertapScript();
    setTimeout(() => {
      this.tempShow = true;
    }, 500);
    this.setWidgetData();
    // handling for service session-timeout error
    this._emitterService.Get(CommonConstants.EmitterEventTypes.SessionExpired).subscribe((isExpired: boolean) => {
      if (isExpired) {
        this.sessionExpired = true;
        this.hideDrawer('clickToCallDrawer');
        this.showSessionExpiryPopup();
      } else {
        this.HideChildModal('sessionExpired');
      }
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const url = event.url;
        this.checkHomePage(event.url) ? this.showToggle = true : this.showToggle = false;
      }
    })
    console.log(this.router.url)
    this._sharedservice.theme = localStorage.getItem('theme');
    this._sharedservice.theme === 'dark' ? this.renderer.addClass(document.body, 'dark') :
      this.renderer.removeClass(document.body, 'dark');
    this._sharedservice.themeChange.subscribe(res => {
      this._sharedservice.theme = localStorage.getItem('theme');
    });

    let appId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.applicationId);
    appId = appId ? this._cookieHandlerService.GetCookie(CommonConstants.CookieKeys.applicationId, appId) : null;
    if (window.name !== '') {
      const applicationId = window.name;
      this._cookieHandlerService.SetCookie(CommonConstants.CookieKeys.applicationId, applicationId, applicationId);
    } else if (window.name === '' && appId && !this._analyticsService.GetDeviceDetails().mobile) {
      window.name = '';
      this._routerService.RouteToNextTask('multitabfailed');
    }
    // handling for ui session-timeout error
    this._appIdleService.expired$.subscribe((isSessionExpired) => {
      if (isSessionExpired) {
        this.showSessionExpiryPopup(() => {
          if (this.countDownTimer) {
            clearInterval(this.countDownTimer);
          }
          this.countDown(CommonConstants.SESSIONEXPIRYTIMER);
        })
      }
    });
  }
  public ngOnDestroy() {
    let applicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.applicationId);
    if (!applicationId) {
      applicationId = window.name;
    }
    if (applicationId) {
      window.name = '';
      this._cookieHandlerService.DeleteCookies([CommonConstants.CookieKeys.applicationId], applicationId);
    }
  }
  private addAnalyticsScript() {
    const path = environment['AnalyticsLink'];
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('src', path);
    scriptTag.setAttribute('async', '');
    document.head.appendChild(scriptTag);
  }

  checkHomePage(url) {
    return ((url === '/') || url.indexOf('getGoingNow') > -1 || url.indexOf('getGoingNowEdit') > -1);
  }
  // lat and long fetch for current location 
  getGeoLocationAttributes() {
    if (this.isMobileFlag != '1' && !sessionStorage.getItem(CommonConstants.CookieKeys.latitude)
      && !sessionStorage.getItem(CommonConstants.CookieKeys.longitude)) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          if (position) {
            this._sessionHandler.SetSession(CommonConstants.CookieKeys.latitude, position.coords.latitude);
            this._sessionHandler.SetSession(CommonConstants.CookieKeys.longitude, position.coords.longitude);
          }
        },
          (error: any) => console.log(error));
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    }

  }
  private loadAnalyticScript() {
    let url: any = window.location.pathname;
    url = url.split('/');
    this.bflJourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
    if (this.bflJourney && this.bflJourney !== undefined) {
      // attach analytic script to head tag
      const script = document.createElement('script');
      const inlineScript = document.createTextNode(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-TX8FNLW');`);
      script.setAttribute('type', 'text/javascript');
      script.appendChild(inlineScript);
      document.head.appendChild(script);
      console.log('Analytic script added..');
    } else {
      const script = document.createElement('script');
      script.setAttribute('src', environment.AnalyticsLink);
      script.setAttribute('type', 'text/javascript');
      document.head.appendChild(script);
      this._adobe_analytics_service.initiPageInfo();
    }
  }
  public backToHomePage(redirectionKey, redirectionValue) {
    const platform = this._sessionHandler.GetSession(CommonConstants.CookieKeys.platform);
    const redirectionUrl = `inssdk://applaunch?redirection_key=${redirectionKey}&Redirection_value=${redirectionValue}`;
    const sdkVersion = this._sessionHandler.GetSession(CommonConstants.CookieKeys.sdkVersion);
    if (sdkVersion && (platform.toLowerCase() === CommonConstants.platforms.ios) || (platform.toLowerCase() === CommonConstants.platforms.android)) {
      window.open(redirectionUrl, '_self');
    }
    else {
      sessionStorage.clear();
      this.show = false;
      if (this.router.url.toLowerCase() === '/getgoingnow') {
        window.location.reload();
      } else {
        this.router.navigate(['/']).then(() => {
          this.HideChildModal('sessionExpired');
        });
      }
    }
  }


  public onExplore() {
    this._sharedService.onExplore('INSINSURANCE', 'HOME');
  }

  public ShowChildModal(id: string, contentType?: string): void {
    if (contentType) {
      this.initContentPopup();
    }
    this.getModalDirectiveInstanceBasedOnId(id).show();
  }
  public HideChildModal(id: string): void {
    this.getModalDirectiveInstanceBasedOnId(id).hide();
  }
  private initContentPopup() {
    this.ContentPopup = {
      Id: 'content-modal',
      Title: 'Riders',
      Config: <CustomModalOptions>{ show: false, closeOption: true }
    };
  }
  private getModalDirectiveInstanceBasedOnId(popupId: string): any {
    return this.PopupComponent.filter((item: PopupComponent, index: number) => {
      return item.id === popupId;
    })[0].modalControl;
  }
  public showSessionExpiryPopup(callback?) {
    this._sessionHandler.SetSession(CommonConstants.CookieKeys.ssoEnabled, false);
    this.ShowChildModal('sessionExpired');
    if (callback) {
      callback();
    }
  }

  public countDown(count: number) {
    this.counting = count;
    this.sessionExpired = false;
    this.countDownTimer = setInterval(() => {
      if (this.counting <= 0) {
        this.sessionExpired = true;
        clearInterval(this.countDownTimer);
        return false;
      } else {
        this.counting = this.counting - 1;
      }
    }, 1000);
  }

  public closeSessionPopup() {
    this.HideChildModal('sessionExpired');
    this._appIdleService.stopTimer();
    this.backToHomePage('INSCATEGORY', 'HEALTH');
  }

  public sessionExtend() {
    const applicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.applicationId);
    if (applicationId) {
      const payloadObject = {
        'payload': {
          'applicationId': applicationId
        }
      };
      this._appIdleService.extendSession(payloadObject).subscribe((response) => {
        if (response && response['error']) {
          console.log('Error in extending user session :: ', response['error']);
        } else {
          this._appIdleService.resetTimer();
          this.HideChildModal('sessionExpired');
        }
      }, (error) => {
        console.log('Error in extending user session :: ', error);
      });
    }
  }

  public clickToCall() {
    const requestData = {
      payload: {
        'leadType': 'dropoff',
        'applicationId': this._sessionHandler.GetSession(CommonConstants.CookieKeys.applicationId)
      },
    };
    this._needHelpService.PostClickToCall(requestData).subscribe((response) => {
      this.openDrawer('clickToCallDrawer');
      if (response && !response.error && response.payload) {
      } else {
      }
    },
      () => {
      });
  }

  public openDrawer(itemId) {
    this.isDrawerOpen = true;
    this.drawer.filter((item) => {
      return (itemId === item.drawerId);
    })[0].open();
  }
  // close drawer
  public hideDrawer(itemId) {
    this.isDrawerOpen = false;
    this.drawer.filter((item) => {
      return (itemId === item.drawerId);
    })[0].close();
  }

  public listenToHelpCtaEvent() {
    this._needHelpService.getHelpDrawerObservable().subscribe((eventName: string) => {
      if (eventName === 'open') {
        this.openDrawer('clickToCallDrawer');
      } else {
        this.hideDrawer('clickToCallDrawer');
      }
    });
  }

  loadClevertapScript() {

    // Generate script content based on the environment
    const scriptContent = this.generateScriptContent();
    // Create a script element
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = scriptContent;

    // Append the script to the head element
    this.renderer.appendChild(document.head, script);
  }

  generateScriptContent() {

    return `
        
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('./assets/js/service-worker.js', {
          scope: '/'
      }).then((reg) => {
          console.debug('Registration failed with');
      }).catch((error) => {
          console.debug('Registration failed with ' + error);
      });
  }

  var clevertap = {
      event: [],
      profile: [],
      region: 'in1',
      account: [],
      onUserLogin: [],
      notifications: [],
      privacy: []
  };
  const searchParams = new URLSearchParams(window.location.search), isWebView = ("1" === searchParams.get("isMobile")) || (sessionStorage.getItem('source') === 'mobileApp');
  if (isWebView) { // for app
    clevertap.account.push({ id: '${environment.clevertapId.app}' });
} else { // for web
    clevertap.account.push({ id: '${environment.clevertapId.web}' });
}
  clevertap.privacy.push({ optOut: !1 }), clevertap.privacy.push({ useIP: !0 });
  (function () {
      var wzrk = document.createElement('script');
      wzrk.type = 'text/javascript';
      wzrk.async = true;
      wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' :
          'http://static.clevertap.com') + '/js/clevertap.min.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(wzrk, s);
  })();

  function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  var varAuthType;
  try {
      var a = getCookie("authType");
      if (a == "I" || a == "A") {
          varAuthType = "Identified";
      }
      else {
          varAuthType = "UnIdentified";
      }
  } catch (err) {
      varAuthType = "NA";
  }
  clevertap.event.push("page_view", {
      "page_url": document.URL,
      "authType": varAuthType,
  });
  var isPWA = 0;
  try {
      isPWA = window.matchMedia("(display-mode: standalone)").matches ? 1 : 0;
  }
  catch (a) {
      isPWA = 0;
  }
  isWebView || clevertap.event.push("page_view", { page_url: document.URL, authType: varAuthType });
      `;
  }

  /**
   * Method for writing session variables for joruney use.
   * Use for Session continuation from widget page.
   */
  private setWidgetData() {
    const queryParamList = new URLSearchParams(window.location.search);
    let srcValue = queryParamList.get('src');
    let _src = (srcValue != undefined && srcValue != null) ? srcValue : '';
    if (_src == 'widget') {
      localStorage.setItem('theme', 'light');
      for (const key in CommonConstants.CookieKeys.widget) {
        console.log(key, " value = " + CommonConstants.CookieKeys.widget[key]);
        const _value = queryParamList.get(CommonConstants.CookieKeys.widget[key]);
        if (_value) {
          this._sessionHandler.SetSession(CommonConstants.CookieKeys[key], _value);
        }
      }
      this.router.navigate(
        ['/planDetail'],
        {
          queryParams: {
            h_widget_processId: null,
            h_widget_applicationId: null,
            h_widget_quoteId: null,
            h_widget_SS_1: null,
            h_widget_SS_2: null,
            h_widget_SS_4: null,
            h_widget_groupHealthEligible: null,
            src: null,
          },
          queryParamsHandling: 'merge',
        }
      );
    }
  }

}
